import { ArrowLeft, Construction, Home } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function UnderDevelopment() {
  const navigate = useNavigate();

  return (
    <div
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: "var(--color-background)" }}
    >
      <div className="text-center px-6 max-w-2xl">
        <div
          className="w-24 h-24 rounded-2xl mx-auto mb-6 flex items-center justify-center"
          style={{ backgroundColor: "var(--color-warning-light)" }}
        >
          <Construction className="w-12 h-12" style={{ color: "var(--color-warning-600)" }} />
        </div>

        <h1 className="text-3xl font-bold mb-3" style={{ color: "var(--color-text-primary)" }}>
          Page Under Development
        </h1>

        <p className="text-lg mb-8" style={{ color: "var(--color-text-tertiary)" }}>
          This feature is currently being developed and will be available soon.
          <br />
          Thank you for your patience.
        </p>

        <div className="flex items-center justify-center gap-3">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-6 py-2.5 border border-slate-300 text-slate-700 font-semibold rounded-lg hover:bg-slate-50 transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Go Back
          </button>
          <button
            onClick={() => navigate("/dashboard")}
            className="inline-flex items-center gap-2 px-6 py-2.5 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors"
          >
            <Home className="w-4 h-4" />
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}
